"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCountries = fetchCountries;
exports.fetchCountry = fetchCountry;
exports.fetchEmployerOnboardingCountries = fetchEmployerOnboardingCountries;
exports.fetchRegions = fetchRegions;

var _camelcaseKeys = _interopRequireDefault(require("camelcase-keys"));

var _ApiClient = _interopRequireDefault(require("./ApiClient"));

var _defaults = require("./defaults");

function fetchCountries() {
  return _ApiClient["default"].get("".concat(_defaults.V1ApiEndpoint, "/countries"));
}

function fetchCountry(countrySlug) {
  return _ApiClient["default"].get("".concat(_defaults.V1ApiEndpoint, "/countries/").concat(countrySlug), {
    transformResponse: function transformResponse(response) {
      return (0, _camelcaseKeys["default"])(JSON.parse(response), {
        deep: true
      });
    }
  });
}

function fetchEmployerOnboardingCountries() {
  return _ApiClient["default"].get("".concat(_defaults.V1ApiEndpoint, "/countries/employer-onboarding"));
}

function fetchRegions() {
  return _ApiClient["default"].get("".concat(_defaults.V1ApiEndpoint, "/countries/regions"));
}